import { PagedList } from '../../admin/types/pagination';
import { MainV3ApiBase } from './base';
import { LessonHomeworkId } from '../../commonv3/types/lesson_homeworks';
import { LessonHomeworkSubmissionIndexView } from '../types/lesson_homework_submissions';

export const LessonHomeWorksSubmissionApis = {
  async findAll(page = 1, id: LessonHomeworkId): Promise<PagedList<LessonHomeworkSubmissionIndexView>> {
    return PagedList.fromJson(
      await MainV3ApiBase.appendPath('lesson_homeworks/:id/lesson_homework_submissions').bind({ id }).get({ page })
    );
  },
};
